import { useNavigate } from 'react-router-dom';

export function Footer() {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-[#1a365d] to-[#2c5282] text-white">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-3 gap-12 mb-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg">
                <i className="ri-shield-check-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold" style={{ fontFamily: "'Noto Sans TC', sans-serif" }}>
                康普斯智產權事務所
              </h3>
            </div>
            <p className="text-white/70 text-sm leading-relaxed">
              專業、可信賴的智慧財產權顧問，協助您保護創新成果，建立競爭優勢。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4" style={{ fontFamily: "'Noto Sans TC', sans-serif" }}>
              快速連結
            </h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  首頁
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    const element = document.getElementById('services');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  服務項目
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/about-ip')}
                  className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  關於我們
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    const element = document.getElementById('contact');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  聯絡我們
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4" style={{ fontFamily: "'Noto Sans TC', sans-serif" }}>
              聯絡資訊
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-sm">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-map-pin-line text-white/70"></i>
                </div>
                <span className="text-white/70 leading-relaxed">
                  台北市信義區基隆路二段189號3樓之5
                </span>
              </li>
              <li className="flex items-center gap-3 text-sm">
                <div className="w-4 h-4 flex items-center justify-center shrink-0">
                  <i className="ri-phone-line text-white/70"></i>
                </div>
                <a href="tel:0227361182" className="text-white/70 hover:text-white transition-colors cursor-pointer">
                  (02) 2736-1182
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm">
                <div className="w-4 h-4 flex items-center justify-center shrink-0">
                  <i className="ri-mail-line text-white/70"></i>
                </div>
                <a href="mailto:complus@ms21.hinet.net" className="text-white/70 hover:text-white transition-colors cursor-pointer">
                  complus@ms21.hinet.net
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm">
                <div className="w-4 h-4 flex items-center justify-center shrink-0">
                  <i className="ri-time-line text-white/70"></i>
                </div>
                <span className="text-white/70">週一至週五 9:00 - 18:00</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/60">
            <div>
              © {currentYear} 康普斯智產權事務所 版權所有
            </div>
            <div className="flex items-center gap-6">
              <button
                onClick={() => navigate('/privacy-policy')}
                className="hover:text-white transition-colors cursor-pointer"
              >
                隱私權政策
              </button>
              <span className="text-white/30">|</span>
              <span className="text-xs">
                本網站所提供之資訊不構成法律意見
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}